import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import api from '@tutorbot/directory-api';
import { LocalizationContext } from '../../hoc/Localization';
import { SettingsContext } from '../../hoc/Settings';
import { RouteContext } from '../../hoc/Route';
import BlogBody from '../../components/Blog/BlogBody';
import ModalSubscribe from './modalSubscribe';

const Blog = ({ categories, seeMoreRoute, category }) => {
  const initialData = [{}, {}, {}, {}, {}, {}];
  const [blogs, setBlogs] = React.useState([
    {
      title: '',
      data: initialData,
    },
  ]);

  const {
    domainSettings: { blogCountry },
  } = React.useContext(SettingsContext);
  const { t, blogLocale, translate } = React.useContext(LocalizationContext);
  const { page } = React.useContext(RouteContext);

  React.useEffect(() => {
    setBlogs([
      {
        title: '',
        data: initialData,
      },
    ]);

    (async () => {
      if (!category) {
        // eslint-disable-next-line
        categories = (await api()
          .categories.where('showBlog', true)
          .all())
          .map(o => ({
            id: o.blogCategory,
            categoryData: o,
            label: o.label,
            blogOrderPriority: o.blogOrderPriority,
          }))
          .filter(o => o.id)
          .sort((a, b) => {
            if (!a.blogOrderPriority) {
              return 1;
            }
            if (!b.blogOrderPriority) {
              return -1;
            }
            if (a.blogOrderPriority > b.blogOrderPriority) {
              return 1;
            }
            if (a.blogOrderPriority < b.blogOrderPriority) {
              return -1;
            }

            return 0;
          });
      }

      const fetchedData = await Promise.all(
        categories.map(async o => ({
          title: o.categoryData
            ? translate(o.categoryData, 'title') || translate(o.categoryData, 'Name')
            : '',
          description: o.categoryData ? translate(o.categoryData, 'description') : '',
          data: (await api()
            .blog.limit(9999)
            .where('categories', blogCountry)
            .where('categories', blogLocale)
            .where('categories', o.id)
            .sort({ date: 'desc' })
            .get()).data,
          label: o.label,
        })),
      );
      if (page === 'blog') {
        fetchedData.push({
          title: t('blog.section.91'),
          data: (await api()
            .blog.limit(9999)
            .where('categories', blogCountry)
            .where('categories', blogLocale)
            .where('categories', 94)
            .sort({ date: 'desc' })
            .get()).data,
          label: 'other',
        });
      }

      setBlogs(fetchedData);
    })();
  }, [blogLocale]);

  return (
    <React.Fragment style={{ overflow: 'auto' }}>
      <Head>
        <title>{`${t('meta.blog.title')} | ${t('meta.title.suffix')}`}</title>
        <meta name="description" content={t('meta.blog.description')} />
      </Head>

      <ModalSubscribe />
      {blogs.map(
        blog =>
          !!(blog.data && blog.data.length) && (
            <BlogBody
              blog={blog}
              category={category}
              seeMoreRoute={seeMoreRoute}
              isDetail={categories.length === 1}
            />
          ),
      )}
    </React.Fragment>
  );
};

Blog.propTypes = {
  category: PropTypes.string,
  categories: PropTypes.array,
  seeMoreRoute: PropTypes.string,
};

Blog.defaultProps = {
  category: '',
  categories: [],
  seeMoreRoute: '',
};

Blog.getInitialProps = async () => ({});
export default Blog;
